import { useEffect } from 'react';
import { useLocation } from 'react-router';

export const useScrollIntoView = (timeout = 0, top = 64) => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash === '') {
      window.scrollTo();
    } else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          window.scrollTo({ top: element.offsetTop - top, behavior: 'smooth' });
        }
      }, timeout);
    }
  }, [pathname, hash, key]);
};
